import React, { useRef, useState, useEffect } from 'react';
import { useServiceContext } from '../../components/Context/ServiceContext';
import Dashboard from '../../views/AdminView/Dashboard';



const DashboardCompoent = () => {

    const data = useRef('');
    const [loading, setLoading] = useState(true);
    const didFetch = useRef(false);

    const error = useRef('');
    const { service, GetServices } = useServiceContext();
    const getData = async () => {

        try {

            //         const response = await fetchPartner();
            //         data.current = response.data;
            await GetServices();
            setLoading(false); // Set loading to false once data is fetched
            //          
            //         console.log(response.data);

        } catch (error) {
            console.error('Error fetching data:', error);
            error.current = 'Failed to fetch data.';
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            getData();
            didFetch.current = true; // Mark the API call as done
        }
    });

    return (
        <div>{<Dashboard />}</div>
            
      
    )

};

export default DashboardCompoent;
